import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DepartureTicketInfo } from '../../schema/departure-ticket-info';

@Injectable({
  providedIn: 'root'
})
export class DepartureTicketInfoProxyService {
  constructor(private httpClient: HttpClient) {}

  getDepartureTicketInfo(callcardId: string): Observable<DepartureTicketInfo> {
    const params = new HttpParams({ fromObject: { callCardUid: callcardId } });
    return this.httpClient.get<DepartureTicketInfo>('api/Callcard/GetDepartureTicketInfo', { params });
  }
}
